import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * The old /reset-password?token=... link-based flow has been replaced by an
 * OTP code flow in /forgot-password. Redirect anyone landing here.
 */
const ResetPassword = () => <Navigate to="/forgot-password" replace />;

export default ResetPassword;
